import React from 'react';
import { useIntl } from 'react-intl';

import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';
import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';

export interface GroupSuccessScreenProps {
  onClose: () => void;
  isEditMode: boolean;
}

export const GroupSuccessScreen = ({ onClose, isEditMode }: GroupSuccessScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={
          isEditMode
            ? intl.formatMessage({
                id: 'predict.schedule_changes_saved',
                defaultMessage: 'Changes saved'
              })
            : intl.formatMessage({
                id: 'common.group_created',
                defaultMessage: 'Group created'
              })
        }
      />
    </WizardScreen>
  );
};
